// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 971) return "static/css/971.d4a9c58771835c776dc4.lib.css";
	if (chunkId === 639) return "static/css/639.68c2572221c8393da78c.css";
	// return url for filenames based on template
	return undefined;
};